/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { FilledButton, Popover, Select } from '@neo4j-ndl/react';
import { useState } from 'react';

const offsetOptions = [
  {
    label: 'crossAxis-anchor-element-width',
    value: 'crossAxis-anchor-element-width',
  },
  {
    label: 'crossAxis-anchor-element-negative-width',
    value: 'crossAxis-anchor-element-negative-width',
  },
  {
    label: 'crossAxis-floating-element-negative-width',
    value: 'crossAxis-floating-element-negative-width',
  },
  {
    label: 'crossAxis-floating-element-width',
    value: 'crossAxis-floating-element-width',
  },
];

const offsetTranslation: Record<
  string,
  React.ComponentProps<typeof Popover>['offset']
> = {
  'crossAxis-anchor-element-negative-width': ({ rects }) => ({
    crossAxis: -rects.reference.width,
  }),
  'crossAxis-anchor-element-width': ({ rects }) => ({
    crossAxis: rects.reference.width,
  }),
  'crossAxis-floating-element-negative-width': ({ rects }) => ({
    crossAxis: -rects.floating.width,
  }),
  'crossAxis-floating-element-width': ({ rects }) => ({
    crossAxis: rects.floating.width,
  }),
};

const Component = () => {
  const [selectedPosition, setSelectedPosition] = useState(
    offsetOptions[0].value,
  );

  return (
    <div className="n-flex n-flex-col n-gap-token-32 n-items-center">
      <Popover offset={offsetTranslation[selectedPosition]}>
        <Popover.Trigger hasButtonWrapper>
          <FilledButton>Open Popover</FilledButton>
        </Popover.Trigger>
        <Popover.Content className="n-p-token-16">
          Popover content
        </Popover.Content>
      </Popover>

      <Select
        type="select"
        label="Example positions"
        selectProps={{
          defaultValue: offsetOptions[0],
          onChange: (e) => {
            if (e) {
              setSelectedPosition(e.value);
            }
          },
          options: offsetOptions,
        }}
      />
    </div>
  );
};

export default Component;
